module.exports = __webpack_public_path__ + "assets/img/img-course-plan03.33745478.png";